module.exports = __webpack_public_path__ + "img/image22.c11d9bdf.png";